module.exports = __webpack_public_path__ + "assets/480213ee44924ea2b87517afc87cb808.mp4";